import { render, staticRenderFns } from "./WysiwygTextEditor.vue?vue&type=template&id=5a5a2c4d&"
import script from "./WysiwygTextEditor.vue?vue&type=script&lang=js&"
export * from "./WysiwygTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports